import axios from "axios";
import {url} from "../utilities";
import {toastAlert} from "../toastAlert";
import * as $ from "jquery";
import {handleApiForm} from "../forms";
import {confirmModal} from "../confirmModal";

export const contracts_page = () => {

    $("#contractsTable").DataTable({
        order: [1, 'desc'],
        stateSave: false,
    });

}